<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/scheduled/energy']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "ENERGY_REGISTER_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "SCHEDULEDENERGY_SUBTITLE" | translate }}
      </h6>
    </div>
    <div class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5">
      <div class="position-relative">
        <div class="settings-button ps-3 pe-3 pb-2 pt-1" (click)="toggleSelectOption()">
          <svg-icon alt="Settings" class="hover-effect" src="assets/core/table-button/filter.svg"></svg-icon>
        </div>

        <!-- Select Option Modal -->
        <div class="select-option-overlay" *ngIf="isSelectOptionOpen" (click)="closeSelectOption()"></div>
        <div class="select-option-modal" *ngIf="isSelectOptionOpen">
          <div class="select-option-header">
            <span>{{ "SELECT_OPTION" | translate }}</span>
            <img alt="Close" src="assets/device/x.svg" (click)="closeSelectOption()" class="close-icon" />
          </div>
          <div class="select-option-item" (click)="selectReadOption(ReadsType.Processed)">
            <span>{{ "PROCESSED_READ" | translate }}</span>
            <input class="radio-div" type="radio" [checked]="selectedReadOption === ReadsType.Processed" readonly />
          </div>
          <div class="select-option-item" (click)="selectReadOption(ReadsType.Raw)">
            <span>{{ "RAW_READ" | translate }}</span>
            <input type="radio" [checked]="selectedReadOption === ReadsType.Raw" readonly />
          </div>
          <div class="select-option-footer">
            <button class="apply-btn" (click)="applyReadOption()">{{ "APPLY" | translate }}</button>
          </div>
        </div>
      </div>

      <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
        <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg"></svg-icon>
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 pt-3 ps-5 pb-3">
    <div class="datepicker-container-wrapper position-relative">
      <div class="button-wrapper">
        <div class="button">
          <img alt="Date" src="assets/core/table-button/date.svg" />
          <div class="button-text" (click)="toggleModal()"
            [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
            <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
              {{ selectedDate }}
            </ng-container>
            <ng-template #noDateSelected>
              <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
            </ng-template>
          </div>
          <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
            (click)="clearDates()" />
        </div>
      </div>
      @if (isDatepickerOpen) {
      <div class="overlay" (click)="toggleModal()"></div>
      <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
      }
    </div>
  </div>
  <div #tableContainer class="table-container">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}
          </td>
          <td>{{ "ENERGYREGISTERS_ABSOLUTEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_ACTIVEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_REACTIVEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_APPARENTENERGY" | translate | uppercase }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Absolute Energy -->
          <td>
            {{ item.absoluteActiveEnergy == null ? "N/A" :
            item.absoluteActiveEnergy | unitConverter: "WH" }}
          </td>

          <!-- Active Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.activeEnergyImport + ' WH'">
                {{ item.activeEnergyImport == null ? "N/A" :
                item.activeEnergyImport | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.activeEnergyExport + ' WH'">
                {{ item.activeEnergyExport == null ? "N/A" :
                item.activeEnergyExport | unitConverter: "WH" }}
              </span>
            </div>
          </td>

          <!-- Reactive Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.reactiveEnergyImport + ' VARH'">
                {{ item.reactiveEnergyImport == null ? "N/A" :
                item.reactiveEnergyImport | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.reactiveEnergyExport + ' VARH'">
                {{ item.reactiveEnergyExport == null ? "N/A" :
                item.reactiveEnergyExport | unitConverter: "VARH" }}
              </span>
            </div>
          </td>

          <!-- Apparent Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.apparentEnergyImport + ' VAH'">
                {{ item.apparentEnergyImport == null ? "N/A" :
                item.apparentEnergyImport | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.apparentEnergyExport + ' VAH'">
                {{ item.apparentEnergyExport == null ? "N/A" :
                item.apparentEnergyExport | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down mb-5">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>